import { claimLeavesSlice } from './claimLeavesSlice';
import claimLeavesService from '../../services/claimLeaveService';

export const sliceActions = claimLeavesSlice.actions;

export const fetchClaimLeavesList = () => {
  return async dispatch => {
    const records = await claimLeavesService.getClaimLeaves();
    const finalList = records.filter(c => ['N', 'P'].includes(c.Status) && c.Hours - c.UtilizedHours > 0);

    dispatch(sliceActions.setClaimLeavesList(finalList));
  };
};
